<app-sales-payment-information-general (nextStepEvent)="onNextStep()" *ngIf="categoryCode!=Category.kredicash"/>
<app-sales-payment-information-kredicash (gotoStepEvent)="onGotoStep($event)" (nextStepEvent)="onNextStep()" *ngIf="categoryCode==Category.kredicash"/>
